<div class="hd-time-slider" [class.hd-time-slider--busy]="busy()">
  <button
    type="button"
    class="hd-time-slider__tool"
    [attr.aria-label]="(playing() ? 'humanDesign.chart.timeSlider.pause' : 'humanDesign.chart.timeSlider.play') | transloco"
    [title]="(playing() ? 'humanDesign.chart.timeSlider.pause' : 'humanDesign.chart.timeSlider.play') | transloco"
    (click)="togglePlay()"
    data-test-id="time-slider-play"
  >
    <i eIcon [icon]="playing() ? 'pause' : 'play'"></i>
  </button>
  <button
    type="button"
    class="hd-time-slider__tool"
    [disabled]="atStart()"
    [attr.aria-label]="'humanDesign.chart.timeSlider.stepBack' | transloco"
    [title]="'humanDesign.chart.timeSlider.stepBack' | transloco"
    (click)="stepBy(-1)"
    data-test-id="time-slider-step-back"
  >
    <i eIcon icon="backward-step"></i>
  </button>

  <input
    type="range"
    class="hd-time-slider__range"
    min="0"
    [max]="totalMinutes()"
    [step]="stepMinutes()"
    [value]="valueMinutes()"
    [attr.aria-label]="'humanDesign.chart.timeSlider.ariaLabel' | transloco"
    (input)="onSliderInput($any($event.target).value)"
    (change)="onSliderCommit()"
    data-test-id="time-slider-input"
  />

  <button
    type="button"
    class="hd-time-slider__tool"
    [disabled]="atEnd()"
    [attr.aria-label]="'humanDesign.chart.timeSlider.stepForward' | transloco"
    [title]="'humanDesign.chart.timeSlider.stepForward' | transloco"
    (click)="stepBy(1)"
    data-test-id="time-slider-step-forward"
  >
    <i eIcon icon="forward-step"></i>
  </button>

  <div class="hd-time-slider__label-holder">
    <!-- Klikbaar label: springt via een momentkiezer naar een exacte stand binnen het bereik. -->
    <button
      type="button"
      class="hd-time-slider__label"
      [attr.aria-expanded]="pickerOpen()"
      [attr.aria-label]="'humanDesign.chart.timeSlider.pickMoment' | transloco"
      [title]="'humanDesign.chart.timeSlider.pickMoment' | transloco"
      (click)="togglePicker()"
      data-test-id="time-slider-label"
    >
      {{ valueLabel() }}
      @if (busy()) {
        <i eIcon icon="spinner" class="hd-time-slider__busy" [title]="'humanDesign.chart.timeSlider.calculating' | transloco"></i>
      }
    </button>
    @if (pickerOpen()) {
      <div class="hd-time-slider__picker-panel" data-test-id="time-slider-picker-panel">
        <input
          type="datetime-local"
          class="hd-time-slider__picker-input"
          [min]="pickerMin()"
          [max]="pickerMax()"
          [value]="pickerValue()"
          [attr.aria-label]="'humanDesign.chart.timeSlider.pickMoment' | transloco"
          (change)="onPickerChange($any($event.target).value)"
          data-test-id="time-slider-picker-input"
        />
      </div>
    }
  </div>

  <button
    type="button"
    class="hd-time-slider__tool hd-time-slider__anchor"
    [disabled]="atAnchor()"
    [attr.aria-label]="(mode() === 'live' ? 'humanDesign.chart.timeSlider.anchorLive' : 'humanDesign.chart.timeSlider.anchorRange') | transloco"
    [title]="(mode() === 'live' ? 'humanDesign.chart.timeSlider.anchorLive' : 'humanDesign.chart.timeSlider.anchorRange') | transloco"
    (click)="onAnchorClick()"
    data-test-id="time-slider-anchor"
  >
    <i eIcon [icon]="mode() === 'live' ? 'location-crosshairs' : 'backward-fast'"></i>
  </button>
</div>
